import type { QueryFunctionContext } from '@tanstack/react-query';
import { JobsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { jobsKeys } from 'app/queries/jobs/jobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.lockedStatusByJobId>>;

export const createFetchJobLockedStatusQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobsService.getJobLockedStatus({ jobId }), signal));
